import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = true
}: CardProps) {
  return <motion.div whileHover={hoverEffect ? {
    y: -5
  } : undefined} className={`bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl p-6 ${hoverEffect ? 'hover:border-cyan-500/30 hover:shadow-[0_0_30px_rgba(6,182,212,0.1)] transition-all duration-300' : ''} ${className}`} data-id="element-252">
      {children}
    </motion.div>;
}